export const toLocaleNumbers = (num: number, withComma: boolean) => {
	if (withComma) return new Intl.NumberFormat('en-US').format(num);
	return num.toLocaleString();
};
